(function () {
  'use strict';

  angular.module('ringbaPortal').component('tcpaShieldUsage', {
    templateUrl: '/scripts/components/tcpa-shield/tcpa-shield-usage.view.html'
  });
})();
